/* 1.1 22/09/2026
Gestione allegati NEWS con personalizzazione "allegati_news":
- aggiunto allegato opzionale JPG/JPEG/PNG/PDF
- ridimensionamento immagini a massimo 1600x1600
- anteprima e gestione allegato tramite VisualizzaAllegato
- invio multipart/form-data per inserimento e modifica
- con allegati_news il testo è facoltativo se è presente un allegato
*/

import React, {Fragment,useState,useRef} from 'react';
import { useEffect } from 'react';
import {
    Table,Col, Row, Card, CardBody,
    CardTitle, Button, Form, FormGroup, Label, Input , Modal
} from 'reactstrap';
import Parametri from '../../parametri';
import TrasformaDateAUmano from '../TrasformaDateAUmano.js';
import Clessidra from '../Clessidra.js';
import Modale from '../Modale.js';
import FinestraDialogo from '../FinestraDialogo.js';
import Resizer from "react-image-file-resizer";
import VisualizzaAllegato from '../VisualizzaAllegato.js';
import { haPersonalizzazione } from '../../funzioni.js';

const STATO_INDEFINITO = 0;
const STATO_INSERISCI = 1;
const STATO_MEMORIZZAZIONE = 2;//utilizzato per eseguire le operazioni di inserimento/modifica/eliminazione record
const STATO_ERRORE_CONNESSIONE = 3;
const STATO_OPERAZIONE_FALLITA = 4;
const STATO_RICERCA_DATI = 5;//utilizzato nel caso modifica e cancella quando vado a ricercare i dati per popolare i campi della scheda
const STATO_RICERCA_DATI_CORRETTA = 6;//utilizzato a valle della ricerca dati record in caso di modifica o cancellazione di un record


function FormGridFormRow(props) {

    var today = new Date();
    let sMese = String(today.getMonth()+1);
    if(sMese.length === 1) sMese = "0"+sMese;
    let sGiorno = String(today.getDate());
    if(sGiorno.length === 1) sGiorno = "0"+sGiorno;

    const dataOggi = today.getFullYear()+'-'+sMese+'-'+sGiorno;

    const dataEliminazionePredefinita = new Date();
    dataEliminazionePredefinita.setDate(dataEliminazionePredefinita.getDate() + 30);

    let sMeseEliminazione = String(dataEliminazionePredefinita.getMonth() + 1);
    if (sMeseEliminazione.length === 1) sMeseEliminazione = "0" + sMeseEliminazione;

    let sGiornoEliminazione = String(dataEliminazionePredefinita.getDate());
    if (sGiornoEliminazione.length === 1) sGiornoEliminazione = "0" + sGiornoEliminazione;

    const dataEliminazione30Giorni =
        dataEliminazionePredefinita.getFullYear() +
        '-' +
        sMeseEliminazione +
        '-' +
        sGiornoEliminazione;

    const [operazione,setOperazione] = useState('');
    const [variazioneCampi,setvariazioneCampi]=useState(0);

    const [flagAttivaModaleRichiestaDataEliminazione, setFlagAttivaModaleRichiestaDataEliminazione] = useState(0);
    const [flagAttivaModaleRichiestaTitolo, setFlagAttivaModaleRichiestaTitolo] = useState(0);
    const [flagAttivaModaleRichiestaTesto, setFlagAttivaModaleRichiestaTesto] = useState(0);
    const [flagAttivaModaleDoppione, setFlagAttivaModaleDoppione] = useState(0);
    const [flagAttivaModaleNonModificabile, setFlagAttivaModaleNonModificabile] = useState(0);
    const [flagAttivaModaleNonEliminabile, setFlagAttivaModaleNonEliminabile] = useState(0);
    const [flagAttivaModaleRichiestaTestoOAllegato, setFlagAttivaModaleRichiestaTestoOAllegato] = useState(0);

    const titolo   = useRef();
    const testo   = useRef();
    //const dataInsMod   = useRef();
    const dataEliminazione   = useRef();
    const [statoPagina,setStatoPagina]=useState(STATO_INDEFINITO);
    const [error,setError]=useState('');
    //const [risultatoServer,setRisultatoServer]=useState('');
  
    const [titoloDefault,setTitoloDefault] = useState('');
    const [testoDefault,setTestoDefault] = useState('');
    const [dataInsModDefault,setDataInsModDefault] = useState(dataOggi);
    const [dataEliminazioneDefault,setDataEliminazioneDefault] = useState(
      props.ope === "inserisci" ? dataEliminazione30Giorni : ''
    );

    const [contenutoFileAllegato,setContenutoFileAllegato] = useState('');
    const [typeFileAllegato,setTypeFileAllegato] = useState('');
    const [estensioneFileAllegato,setEstensioneFileAllegato] = useState('');
    const [flagAllegatoModificato,setFlagAllegatoModificato] = useState(false);
    const [flagEliminaAllegato,setFlagEliminaAllegato] = useState(false);
    const [semaforoElaborazioneAllegato,setSemaforoElaborazioneAllegato] = useState(false);
    
    const [disabilitaBottoni,setDisabilitaBottoni]= useState(false);
    const [loading,setLoading]= useState(false);
   
    useEffect(() => {
        setStatoPagina(STATO_INSERISCI);
    },[]);

    useEffect(() => {
        if(props.ope==='inserisci') setOperazione("newsIns");
        if(props.ope==='modifica') setOperazione("newsMod");
        if(props.ope==='cancella') setOperazione("newsCanc");

        if(props.ope==="modifica" || props.ope==="cancella"){
            //devo eseguire una fetch per popolare i campi della scheda con i dati presi da db per il record in esame:
            // parametri per inviare i dati al server:
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({op:"newsRecuperaDati",
                    id:props.id,
                    emak: props.emak,
                    sessionId:props.sessionId
                })
            };
            setStatoPagina(STATO_RICERCA_DATI);

            fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
                .then(risposta => risposta.json())
                .then(
                    (valoreDiRitorno) => {
                        if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                            alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
                        }
                        if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                        if(valoreDiRitorno.risultatoOperazione===1){
                        //setRisultatoServer(valoreDiRitorno.risultatoRitorno);
                        setTitoloDefault(valoreDiRitorno.risultatoRitorno[0].TITOLO);
                        setTestoDefault(valoreDiRitorno.risultatoRitorno[0].TESTO);
                        setDataInsModDefault(valoreDiRitorno.risultatoRitorno[0].DATA_INS_MOD);
                        setDataEliminazioneDefault(valoreDiRitorno.risultatoRitorno[0].DATA_ELIMINAZIONE);
                        setStatoPagina(STATO_RICERCA_DATI_CORRETTA);


                        if (haPersonalizzazione(props.identitaSelezionata, "allegati_news")) {
                            setContenutoFileAllegato(
                                valoreDiRitorno.risultatoRitorno[0].FILE === undefined
                                    ? ""
                                    : valoreDiRitorno.risultatoRitorno[0].FILE
                            );

                            setTypeFileAllegato(
                                valoreDiRitorno.risultatoRitorno[0].TYPE === undefined
                                    ? ""
                                    : valoreDiRitorno.risultatoRitorno[0].TYPE
                            );

                            setEstensioneFileAllegato(
                                valoreDiRitorno.risultatoRitorno[0].ESTENSIONE_FILE === undefined
                                    ? ""
                                    : valoreDiRitorno.risultatoRitorno[0].ESTENSIONE_FILE
                            );

                            setFlagAllegatoModificato(false);
                            setFlagEliminaAllegato(false);
                        }


                    }
                    },
                (error) => {setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
            ); 
        }else setStatoPagina(STATO_RICERCA_DATI_CORRETTA);
    },[props.ope]);

    function tornaElenco() {
        props.callbackTermineModifica();
    }

    function tornaScheda(valore) {
        setFlagAttivaModaleRichiestaDataEliminazione(0);
        setFlagAttivaModaleRichiestaTitolo(0);
        setFlagAttivaModaleRichiestaTesto(0);
        setFlagAttivaModaleDoppione(0);
        setFlagAttivaModaleNonModificabile(0);
        setFlagAttivaModaleNonEliminabile(0);
    }

    function handleCambiamentoMod(event) {
        //event.preventDefault();
        setvariazioneCampi(1);
    }

    function aggiornaFileAllegato(event) {

        const valore = event.target.files[0];

        if (!valore) return;

        /*
        * Per le NEWS limitiamo i PDF a 5 MB.
        * Le immagini vengono ridimensionate prima dell'invio.
        */
        if (valore.type === "application/pdf" && valore.size > 5000000) {
            alert("Seleziona un PDF che non sia più grande di 5 MB");
            return;
        }

        let typeFile = valore.type;
        let estensione = valore.name.split('.').pop().toLowerCase();

        if (
            estensione !== "jpg" &&
            estensione !== "jpeg" &&
            estensione !== "png" &&
            estensione !== "pdf"
        ) {
            alert("Sono ammessi solamente file JPG, JPEG, PNG o PDF");
            return;
        }

        if (valore.type.substring(0,5) === "image") {

            if (semaforoElaborazioneAllegato) return;

            setSemaforoElaborazioneAllegato(true);

            let nuovoTipo = valore.type.substring(6);

            if (
                nuovoTipo.toUpperCase() !== "JPG" &&
                nuovoTipo.toUpperCase() !== "JPEG" &&
                nuovoTipo.toUpperCase() !== "PNG"
            ) {
                nuovoTipo = "JPEG";
                typeFile = "image/jpeg";
                estensione = "jpg";
            }

            try {

                Resizer.imageFileResizer(
                    valore,
                    1600,
                    1600,
                    nuovoTipo,
                    90,
                    0,
                    (uri) => {
                        setContenutoFileAllegato(uri);
                        setTypeFileAllegato(typeFile);
                        setEstensioneFileAllegato(estensione);

                        setFlagAllegatoModificato(true);
                        setFlagEliminaAllegato(false);
                        setvariazioneCampi(1);

                        setSemaforoElaborazioneAllegato(false);
                    },
                    "base64"
                );

            } catch (err) {

                setSemaforoElaborazioneAllegato(false);

                alert(
                    "Si è verificato un errore nel ridimensionamento dell'immagine, contattare l'assistenza tecnica"
                );
            }

        } else {

            if (valore.type !== "application/pdf") {
                alert("Sono ammessi solamente file JPG, JPEG, PNG o PDF");
                return;
            }

            setContenutoFileAllegato(valore);
            setTypeFileAllegato("application/pdf");
            setEstensioneFileAllegato("pdf");

            setFlagAllegatoModificato(true);
            setFlagEliminaAllegato(false);
            setvariazioneCampi(1);
        }
    }    

    function eliminaAllegato() {

        setContenutoFileAllegato("");
        setTypeFileAllegato("");
        setEstensioneFileAllegato("");

        setFlagAllegatoModificato(false);
        setFlagEliminaAllegato(true);

        setvariazioneCampi(1);
    }

    function fetchOperazioneServer(bypassaControlli=0) {
        //invio l'azione da fare sul server (aggiungi/togli) e l'elemento in esame al server che mi ritornerà l'elenco aggiornato
        let controlli=0;
        //cancello comunque;
        if(props.ope!=='cancella' && bypassaControlli===0){

            if(testo.current.value.length>64000){
                controlli = 1;
                alert("Il Testo contiene troppi caratteri (massimo accettato 64000)");
                setDisabilitaBottoni(false);
            }

            if(dataEliminazione.current.value=== ''){
                controlli = 1;
                setFlagAttivaModaleRichiestaDataEliminazione(1);
            }
            if(titolo.current.value=== ''){
                controlli = 1;
                setFlagAttivaModaleRichiestaTitolo(1);
            }

            // validazione testo
            if (haPersonalizzazione(props.identitaSelezionata, "allegati_news")) {
                if (
                    testo.current.value.trim() === '' &&
                    contenutoFileAllegato === ''
                ) {
                    controlli = 1;
                    setFlagAttivaModaleRichiestaTestoOAllegato(1);
                }

            } else {

                if(testo.current.value === ''){
                    controlli = 1;
                    setFlagAttivaModaleRichiestaTesto(1);
                }
            }
        }

        if(controlli===0){ 

            if(props.ope==='modifica' && variazioneCampi===0){
                //in relatà non e stata fatta alcuna variazione nei campi originali per cui torno ad elenco:
                tornaElenco();
            }else{
                setLoading(true);
                // parametri per inviare i dati al server:
                let requestOptions;

                if (
                    props.ope !== 'cancella' &&
                    haPersonalizzazione(props.identitaSelezionata, "allegati_news")
                ) {

                    const formData = new FormData();

                    formData.append('op',operazione);
                    formData.append('titolo',titolo.current.value);
                    formData.append('testo',testo.current.value);
                    formData.append('dataInsMod',dataInsModDefault);
                    formData.append('dataEliminazione',dataEliminazione.current.value);
                    formData.append('idElemento',props.id);
                    formData.append('emak',props.emak);
                    formData.append('sessionId',props.sessionId);

                    if (flagAllegatoModificato) {

                        /*
                        * Immagine:
                        * contenutoFileAllegato è il data URI base64.
                        *
                        * PDF:
                        * contenutoFileAllegato è l'oggetto File.
                        *
                        * FormData gestisce automaticamente i due casi:
                        * la stringa finisce in $_POST,
                        * il File finisce in $_FILES.
                        */
                        formData.append(
                            'contenutoFileFoto',
                            contenutoFileAllegato
                        );

                        formData.append(
                            'estensioneFileFoto',
                            estensioneFileAllegato
                        );

                        formData.append(
                            'typeFileFoto',
                            typeFileAllegato
                        );
                    }

                    formData.append(
                        'flagEliminaFoto',
                        flagEliminaAllegato ? "on" : ""
                    );

                    requestOptions = {
                        method: 'POST',
                        body: formData
                    };

                } else {

                    requestOptions = {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },

                        body: props.ope !== 'cancella'
                            ?
                            JSON.stringify({
                                op:operazione,
                                titolo:titolo.current.value,
                                testo:testo.current.value,
                                dataInsMod:dataInsModDefault,
                                dataEliminazione:dataEliminazione.current.value,
                                idElemento:props.id,
                                emak:props.emak,
                                sessionId:props.sessionId
                            })
                            :
                            JSON.stringify({
                                op:operazione,
                                idElemento:props.id,
                                emak:props.emak,
                                sessionId:props.sessionId
                            })
                    };
                }
            
                // qui faccio la chiamata alla pagina sul server, quindi ne leggo la risposta che io trasformo in oggetto json 
                // con .json() ottenendo "valore_di_ritorno": in questo oggetto json ho "risultato_ritorno" che metto nella 
                // variabile di stato "risultato_server"
                //setStatoPagina(STATO_MEMORIZZAZIONE);

                fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
                    .then(risposta => risposta.json())
                    .then(
                    (valoreDiRitorno) => {
                        setLoading(false);
                        if(valoreDiRitorno.risultatoOperazione===1) tornaElenco();
                        if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                        if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                            if(valoreDiRitorno.mess !== undefined){
                                if(valoreDiRitorno.mess.indexOf("News priva di data di eliminazione") !== -1){
                                    setFlagAttivaModaleRichiestaDataEliminazione(1);
                                }      
                                if(valoreDiRitorno.mess.indexOf("News priva di titolo") !== -1){
                                    setFlagAttivaModaleRichiestaTitolo(1);
                                }  
                                if(valoreDiRitorno.mess.indexOf("News priva di testo e allegato") !== -1){
                                    setFlagAttivaModaleRichiestaTestoOAllegato(1);
                                }else if(valoreDiRitorno.mess.indexOf("News priva di testo") !== -1){
                                    setFlagAttivaModaleRichiestaTesto(1);
                                }
                                if(valoreDiRitorno.mess.indexOf("News gia presente") !== -1){
                                    setFlagAttivaModaleDoppione(1);
                                }    
                                if(valoreDiRitorno.mess.indexOf("News non modificabile: può modificarla solo l'amministrazione, che l'ha inserita") !== -1){    
                                    setFlagAttivaModaleNonModificabile(1);
                                }    
                                if(valoreDiRitorno.mess.indexOf("News non eliminabile: può eliminarla solo l'amministrazione, che l'ha inserita") !== -1){    
                                    setFlagAttivaModaleNonEliminabile(1);
                                }
                            }else{
                                //altrimenti vado in errore generico
                                setStatoPagina(STATO_OPERAZIONE_FALLITA);
                            }
                        }
                    },
                    (error) => {setLoading(false);setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
                );
            }
        }
    }
  
    return (
        <Fragment>
            
            {/*eccola {props.sessionId}*/}
        
            {statoPagina === STATO_MEMORIZZAZIONE ? <div className="schedaContenitore" style={{height: props.dimensioniApp.yMain}}>
            <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}><Clessidra loading={true}/>
            </div>
            </div> :""}
            {statoPagina === STATO_ERRORE_CONNESSIONE ? <div>Errore: 1News {error.message}</div> :""}
            {statoPagina === STATO_OPERAZIONE_FALLITA ? <div>Errore per operazione errata</div> :""}
            {statoPagina === STATO_RICERCA_DATI ? <div className="schedaContenitore" style={{height: props.dimensioniApp.yMain}}>
            <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}><Clessidra loading={true}/>
            </div>
            </div> :""}

            {statoPagina === STATO_RICERCA_DATI_CORRETTA ?
            <div className="schedaContenitore" style={{height: props.dimensioniApp.yMain}}>

                {flagAttivaModaleRichiestaDataEliminazione===1 ?
                    <Modale 
                        titolo="Richiesta data di eliminazione"
                        flagErrore={true}
                        contenuto={<div>Non è stata indicata la data di eliminazione, che è necessaria</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                    />  
                :""}

                {flagAttivaModaleRichiestaTesto===1 ?
                    <Modale 
                        titolo="Richiesta testo"
                        flagErrore={true}
                        contenuto={<div>Non è stato indicato il testo, che è necessario</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                    />  
                :""}

                {flagAttivaModaleRichiestaTestoOAllegato===1 ?
                    <Modale 
                        titolo="Richiesta testo o allegato"
                        flagErrore={true}
                        contenuto={
                            <div>
                                Non è stato indicato né il testo né un allegato. È necessario indicarne almeno uno.
                            </div>
                        }
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {
                                    setDisabilitaBottoni(false);
                                    tornaScheda();
                                }
                            }    
                        ]}
                    />  
                :""}                    

                {flagAttivaModaleRichiestaTitolo===1 ?
                    <Modale 
                        titolo="Richiesta titolo"
                        flagErrore={true}
                        contenuto={<div>Non è stato indicato il titolo, che è necessario</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                    />

                :""}

                {flagAttivaModaleDoppione===1 ?
                    <Modale 
                        titolo="Informativa doppione"
                        flagErrore={true}
                        contenuto={<div>Il campo titolo è stato valorizzato con un valore che è già presente nel database per un'altra news</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                    />
                :""}

                {flagAttivaModaleNonModificabile===1 ?
                    <Modale 
                        titolo="Informativa news non modificabile"
                        flagErrore={true}
                        contenuto={<div>News non modificabile: può modificarla solo l'amministrazione, che l'ha inserita</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                    />
                :""}

                {flagAttivaModaleNonEliminabile===1 ?
                    <Modale 
                        titolo="Informativa news non eliminabile"
                        flagErrore={true}
                        contenuto={<div>News non eliminabile: può eliminarla solo l'amministrazione, che l'ha inserita</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                    />
                :""}

                <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}>
                        {props.ope === "inserisci" ? <CardTitle>Inserimento News</CardTitle> :""}
                        {props.ope === "modifica" ? <CardTitle>Modifica News</CardTitle> :""}
            
                    
                        <Clessidra loading={loading}/>
                        {props.ope === "cancella" ?
                            <FinestraDialogo 
                                titolo="Conferma eliminazione"
                                flagErrore={true}                                
                                contenuto={<div>
                                    Confermi l'eliminazione della news <b>{titoloDefault}</b> ?<br/>                                    
                                </div>}
                                bottoni={[
                                    {
                                        "etichetta":"Conferma",
                                        "tipo":"primary",
                                        callback:() => {setDisabilitaBottoni(true);fetchOperazioneServer()}
                                    },
                                    {
                                        "etichetta":"Annulla",
                                        "tipo":"primary",
                                        callback: () => {tornaElenco()}
                                    }
                                ]}
                            />                        

                        :
                            <>
                            <Row form>  
                                <Col md={12}>
                                    <FormGroup>
                                        <Label for="titolo">Titolo*</Label>
                                        {props.ope === "inserisci" || props.ope === "modifica" ?
                                            <Input maxLength={200} type="text" name="titolo" id="titolo"
                                            innerRef={titolo} 
                                            placeholder=""
                                            defaultValue={titoloDefault}
                                            onInput={(e)=>{handleCambiamentoMod(e);setTitoloDefault(titolo.current.value)}}/> 
                                        :""}
                                        {props.ope === "cancella" ? <Label>: {titoloDefault}</Label> : ""}
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row form>  
                                <Col md={12}>
                                    <FormGroup>
                                        <Label for="testo">
                                            {haPersonalizzazione(props.identitaSelezionata, "allegati_news")
                                                ? "Testo"
                                                : "Testo*"}
                                        </Label>
                                        {props.ope === "inserisci" || props.ope === "modifica" ?
                                        <Input type="textarea" rows={4} name="testo" id="testo"  defaultValue={testoDefault} innerRef={testo}
                                            placeholder="" onInput={(e)=>{handleCambiamentoMod(e);setTestoDefault(testo.current.value)}}/>
                                        :""}


                        
                                        {props.ope === "cancella" ? <Label>: {testoDefault}</Label> : ""}
                                    </FormGroup>
                                </Col>
                            </Row>

                            {haPersonalizzazione(props.identitaSelezionata, "allegati_news") &&
                                <Row form>
                                    <Col md={12}>
                                        <FormGroup>

                                            <Label>Allegato JPG, PNG o PDF</Label>

                                            {semaforoElaborazioneAllegato ?

                                                <Clessidra loading={true}/>

                                            :

                                                <VisualizzaAllegato
                                                    contenutoFile={contenutoFileAllegato}
                                                    tipoFile={typeFileAllegato}
                                                    estensioneFile={estensioneFileAllegato}

                                                    estensioniAccettate=".jpg,.jpeg,.png,.pdf"

                                                    callbackAggiornaFile={aggiornaFileAllegato}
                                                    callbackElimina={eliminaAllegato}

                                                    flagContenutoModificato={flagAllegatoModificato}

                                                    cssContenitore="newsAllegatoContenitore"
                                                    cssImmagine="newsAllegatoImmagine"
                                                    cssPdf="newsAllegatoPdf"
                                                    cssTestoEstensione="newsAllegatoEstensione"

                                                    disabilitaCambio={false}
                                                />

                                            }

                                        </FormGroup>
                                    </Col>
                                </Row>
                            }                                

                            <Row form>  
                                <Col md={12}>
                                    <FormGroup>
                                        <Label for="dataEliminazione">Data Eliminazione*</Label>
                                        {props.ope === "inserisci" || props.ope === "modifica" ?
                                            <Input maxLength={10} type="date" name="dataEliminazione" id="dataEliminazione"
                                            innerRef={dataEliminazione} 
                                            placeholder=""
                                            defaultValue={dataEliminazioneDefault}
                                            onInput={(e)=>{handleCambiamentoMod(e);}}/> 
                                        :""}
                                        {props.ope === "cancella" ? <Label>: <TrasformaDateAUmano data={dataEliminazioneDefault}></TrasformaDateAUmano></Label> : ""}
                                    </FormGroup>
                                </Col>
                            </Row>
                            </>
                            }
                            
                                
                            </div>
                            <div className="schedaSpazioInferiore">
                            {props.ope === "inserisci" ? <Button disabled={disabilitaBottoni} color="success" className="mt-2 bottoneMargineADestra" onClick={() => {setDisabilitaBottoni(true);fetchOperazioneServer()}}>Inserisci</Button> :""}
                            {props.ope === "modifica" && variazioneCampi === 1? <Button disabled={disabilitaBottoni} color="warning" className="mt-2 bottoneMargineADestra" onClick={() => {setDisabilitaBottoni(true);fetchOperazioneServer()}}>Memorizza Modifiche</Button>:""}
                            
                            <Button disabled={disabilitaBottoni} color="primary" className="mt-2 bottoneMargineADestra" onClick={() => tornaElenco()} >
                            {(variazioneCampi === 1 && props.ope === "modifica") ?  <Fragment> Annulla </Fragment>: <Fragment>Torna all'elenco</Fragment>}
                            </Button>
                            </div>
            </div>
            :""}
        </Fragment>
    );
}
export default FormGridFormRow;
